import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class AnnotationValueEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {number} */
		this.annotation = null;
		/** @type {number} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _AnnotationValueEditDtoProps
	 * @property {number} annotation
	 * @property {number} value
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _AnnotationValueEditDtoProps} AnnotationValueEditDtoProps
	 */
	/**
	 *
	 * @param {AnnotationValueEditDtoProps} props
	 * @returns {AnnotationValueEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.annotation = props.annotation;
		this.value = props.value;
		return this;
	}
}

export default AnnotationValueEditDto;
